<template>
  <e-charts
    ref="line"
    autoresize
    :options="line"
    theme="theme-color"
    auto-resize
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      line: {
        // Make gradient line here
        // visualMap: [{
        //   show: false,
        //   type: 'continuous',
        //   min: 0,
        //   max: 10000,
        // }],
        grid: {
          top: '40px',
          right: '5%',
          bottom: '40px',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          left: 0,
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.optionData.xAxisData,
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 13,
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
          },
        ],
        series: this.optionData.series,
      },
    }
  },
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
